import anime from "animejs";
import { configs } from ".";
import { AppBase } from "./appBase";
import ImgGallery from "./entities/imgGallery";

class AppAbout extends AppBase {
    protected _init() {
        super._init();
        new ImgGallery(document.querySelector("[data-img-gallery]"));

        anime({
            targets: "*[data-anim-counter]",
            innerText: (el) => el.dataset['animCounter'].split(","),
            round: true,
            easing: "easeInOutSine",
            duration: configs.animDurPageChange * 1.75,
            delay: anime.stagger(75, { start: configs.animDurPageChildrenShared * 1.25 }),
        });
    }
}

export const app = new AppAbout();